import React from 'react';
import Select, { selectType } from 'Components/Select';
import RowsSelector from 'Components/RowsSelector';
import YearPicker from 'Components/YearPicker';

const statuses = ['All', 'Approved', 'Incomplete', 'Deactivated', 'Pending'];

export default class FiltersSection extends React.Component {
  getFormattedListForSelect = (nameFieldName, valueFieldName, dataObject, filterFieldName, filterValue) => {
    let formattedList = dataObject.map(entry => ({ name: entry[nameFieldName], value: entry[valueFieldName] }));
    formattedList.sort(({ name: a }, { name: b }) => (a.toLowerCase() > b.toLowerCase() ? 1 : -1));
    formattedList.unshift({ name: 'All', value: 'All' });

    if (filterFieldName) {
      return formattedList.filter(item => item[filterFieldName] === filterValue);
    } else {
      return formattedList;
    }
  };

  _getSelectedItem = (itemValue, itemsList) => {
    const selectedItem = itemsList.find(item => item.value === itemValue);

    if (selectedItem) {
      return selectedItem;
    } else {
      return itemsList[0];
    }
  };

  render() {
    const {
      handleSelectFilter,
      filterState,
      outCount,
      handleRowsSelect,
      rowsCount,
      categories,
      types,
      user,
      currentModelYear,
    } = this.props;

    let categoriesOptions = [];
    let typesOptions = [];

    if (categories.length && types.length) {
      categoriesOptions = this.getFormattedListForSelect('name', 'id', categories);
      typesOptions = filterState.categoryId
        ? this.getFormattedListForSelect(
          'componentTypeName',
          'componentTypeCode',
          categories.find(category => category.id === filterState.categoryId).componentTypes
        )
        : this.getFormattedListForSelect('componentTypeName', 'componentTypeCode', types);
      if (typesOptions.length === 2) typesOptions.shift();
    }

    return (
      <section className='list-scene__utility-section-wrapper'>
        <section className='list-scene__utility-section-filters-wrapper'>
          <div className='list-scene__utility-section-filters-header'>Filter</div>
          <Select
            label='by Category'
            selectionList={categoriesOptions}
            withoutSearch
            defaultItem={this._getSelectedItem(filterState.categoryId, categoriesOptions)}
            itemNameIndicator='name'
            type={selectType.listFilter}
            isLoading={!categoriesOptions.length}
            handleSelect={handleSelectFilter('categoryId')}
          />
          <Select
            label='by Type'
            selectionList={typesOptions}
            withoutSearch
            defaultItem={this._getSelectedItem(filterState.componentType, typesOptions)}
            itemNameIndicator='name'
            type={selectType.listFilter}
            isLoading={!typesOptions.length}
            handleSelect={handleSelectFilter('componentType')}
          />
          <Select
            label='by Status'
            type={selectType.listFilter}
            withoutSearch
            defaultItem={filterState.applicationStatus}
            placeholder='All'
            selectionList={statuses}
            handleSelect={handleSelectFilter('applicationStatus')}
          />
          {user.isInternal() && (
            <YearPicker
              endYear={currentModelYear + 1}
              yearPickAction={handleSelectFilter('submissionDate')}
              label='by Year'
              year={filterState.submissionDate}
              withAllOption
              width={160}
              height={18}
            />
          )}
        </section>

        <section className='list-scene__utility-section-rows-select-wrapper'>
          <RowsSelector allRowsCount={outCount} handleRowsSelect={handleRowsSelect} selectedRowsCount={rowsCount} />
        </section>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/ComponentManufacturer/List/FiltersSection.jsx